import { PropertyType } from '@taxfyle/txf-api-client'

export const RENTAL_PROPERTY_TYPES_MAP: Record<PropertyType, string> = {
  [PropertyType.SingleFamily]: 'Single family residence',
  [PropertyType.MultiFamily]: 'Multi family residence',
  [PropertyType.VacationRental]: 'Vacation rental',
  [PropertyType.Commercial]: 'Commercial property',
  [PropertyType.Land]: 'Land',
  [PropertyType.Royalties]: 'Royalties',
  [PropertyType.SelfRental]: 'Self-rental',
  [PropertyType.Other]: 'Other',
} as const

export const RENTAL_PROPERTY_TYPES = Object.entries(
  RENTAL_PROPERTY_TYPES_MAP,
) as [code: PropertyType, label: string][]
